import clsx from "clsx";
import styles from "./Backdrop.module.css";

interface BackdropProps {
  show: boolean;
  isBlocking?: boolean; // 是否阻擋點擊
}

const Bounce = () => (
  <div className={clsx("size-4 rounded-full bg-secondary", styles["animate-bounce"])} />
);

const Backdrop = ({ show, isBlocking = true }: BackdropProps) => {
  if (!show) return null;

  return (
    <>
      <div
        className={clsx("fixed inset-0 z-backdrop flex items-center justify-center", {
          "pointer-events-none": !isBlocking,
        })}
      >
        <div className="flex h-12 w-24 items-center justify-center gap-2 rounded-md bg-white bg-opacity-90 shadow-md">
          <Bounce />
          <Bounce />
          <Bounce />
        </div>
      </div>
      {isBlocking && <div className="fixed inset-0 z-overlay bg-white/50" />}
    </>
  );
};

export default Backdrop;
